import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskListEarly = () => {
  return (
    <ContentCore />
  )
}

export default TaskListEarly